module.exports = __webpack_public_path__ + "img/logo5.ad07be18.png";